import { defineStore } from 'pinia';
import { getMapRequest } from '@/api/modules/common';
import { RouteRecordRaw } from 'vue-router';

type State = {
  loading: boolean,
  collapse: boolean,
  currentDate: number,
  device: string,
  dicList: TypeObject,
  currentMicroAppRoute: RouteRecordRaw,
  asideActiveRoute: TypeObject,
  modelSwitch: 0 | 1,
}

export const useAppStore = defineStore('_app', {
  state: (): State => ({
    loading: false,
    collapse: false,
    currentDate: new Date().getTime(),
    device: 'desktop',
    dicList: [],
    currentMicroAppRoute: {} as RouteRecordRaw,
    asideActiveRoute: {},
    modelSwitch: (Number(sessionStorage.getItem('modelSwitch')) as 0 | 1) || 0,
  }),
  actions: {
    setLoadingStatus(status: boolean) {
      this.loading = status;
    },
    setDevice(device: string) {
      this.device = device;
    },
    setCollapseStatus(status: boolean) {
      this.collapse = status;
    },
    setCurrentDate(date: number) {
      this.currentDate = date;
    },
    setCurrentMicroAppRoute(route: RouteRecordRaw) {
      this.currentMicroAppRoute = { ...route };
    },
    setAsideActiveRoute(route: TypeObject) {
      this.asideActiveRoute = { ...route };
    },
    getDicList() {
      getMapRequest().then((res) => {
        this.dicList = res?.data || {};
      });
    },
    setModelSwitch(val: 0 | 1) {
      this.modelSwitch = val;
      sessionStorage.setItem('modelSwitch', String(val));
    },

  },
});
